// AppKit sizes are logical points, independent of Retina scale.
export const MAC_SIDEBAR_COLLAPSE_WIDTH = 1000;
export const MAC_MIN_CHAT_WIDTH = 520;
export const MAC_COMPACT_COMPOSER_WIDTH = 620;

export const isCompactMacWindow = width => Number.isFinite(width)
  && width > 0 && width < MAC_SIDEBAR_COLLAPSE_WIDTH;

export const getMacSidebarWidth = (width, preferredWidth) => {
  const requested = Number.isFinite(preferredWidth) ? preferredWidth
    : Number.isFinite(width) && width > 0 ? Math.round(Math.min(320, Math.max(280, width * 0.22))) : 320;
  return Math.min(400, Math.max(260, requested),
    Number.isFinite(width) && width > 0 ? Math.max(260, width - MAC_MIN_CHAT_WIDTH) : 400);
};
